// extracted by mini-css-extract-plugin
export default {"container":"autopay-method_container__+VbWZ","fullView":"autopay-method_fullView__51Fid","shimmer":"autopay-method_shimmer__DKbPh"};